import { HTTP } from './index'

/**
 * Get the routes data by query based on airline, date and airports
 * @param airports									- Airport direction e.g. `TXL/FRA`
 * @param airlineCode								- Airline code such as LH
 * @param date											- Date in format YYYY-MM-DD
 */
function getFlightListByRouteData (airports: string, airlineCode: string, date: string): Promise<any> {
	return HTTP.get(`/flights/route/${airports}/?airline=${airlineCode}&departureDate=${date}`)
		.then(response => {
			return response.data
		})
		.catch(e => {
			// error handling
		})
}

export default {
	getFlightListByRouteData
}
